export default class ModuleStoreClient {
    constructor(baseUrl = 'http://localhost:3000') {
        this.baseUrl = baseUrl;
    }

    buildUrl(p, params) {
        let url = this.baseUrl + p;
        if (params) {
            url += '?' + params.join('&');
        }
        return url;
    }

    xhr(method, url, data, responseType) {
        return new Promise((resolve, reject) => {
            let r = new XMLHttpRequest();
            r.open(method, url);
            r.withCredentials = true;
            if (responseType) {
                r.responseType = responseType;
            }
            r.onload = (e) => {
                if (r.status === 200) {
                    resolve(r.response);
                } else {
                    reject(r.response);
                }
            };
            r.onerror = (e) => {
                reject(e);
            };
            r.send(data)
        });
    }

    async searchModuleMeta() {
        const method = 'GET';
        const url = this.buildUrl('/-/search');
        const data = await this.xhr(method, url);
        return JSON.parse(data);
    }

    async getModuleMeta(id) {
        const method = 'GET';
        const url = this.buildUrl('/' + id);

        const data = await this.xhr(method, url);
        return JSON.parse(data);
    }

    async getModuleBlob(id, version) {
        const method = 'GET';
        // TODO encodeURIComponent
        const url = this.buildUrl('/' + id + '/-/' + id + '-' + version + '.ext');

        const data = await this.xhr(method, url, null /*data*/, 'blob' /*responseType*/);
        return data;
    }

    async registerModule(metaDict, moduleBlob) {
        const method = 'POST';
        const url = this.buildUrl('/' + metaDict.id);

        const form = new FormData();
        form.append('metaDict', JSON.stringify(metaDict));
        form.append('moduleBlob', moduleBlob);

        const data = await this.xhr(method, url, form);
        return data;
    }

    async login(code) {
        const method = 'POST';
        const url = this.buildUrl('/-/auth/login');

        const data = await this.xhr(method, url, code);
        return JSON.parse(data);
    }

    async checkLogin() {
        const method = 'GET';
        const url = this.buildUrl('/-/auth/me');

        const data = await this.xhr(method, url);
        return JSON.parse(data);
    }

    async logout() {
        const method = 'GET';
        const url = this.buildUrl('/-/auth/logout');

        const data = await this.xhr(method, url);
        return JSON.parse(data);
    }

    async toggleModuleVisible(metaDict) {
        const method = 'POST';
        const url = this.buildUrl(`/${metaDict.id}/${metaDict.version}/visible`);

        const data = await this.xhr(method, url, JSON.stringify(metaDict));
        const res = await JSON.parse(data);
        if (res.error){
            return ({error: res.error});
        }

        return ({result: 'OK'});
    }

    async deleteModuleByVersion(metaDict) {
        const method = 'DELETE';
        const url = this.buildUrl(`/${metaDict.id}/${metaDict.version}`);

        const data = await this.xhr(method, url);
        const res = await JSON.parse(data);
        if (res.error){
            return ({error: res.error});
        }

        return ({result: 'OK'});
    }

    async deleteModule(metaDict){
        const data = await this.searchModuleMeta();
        const modules = data.Items.filter(item => item.id === metaDict.id);

        for (const module of modules){
            const method = 'DELETE';
            const url = this.buildUrl(`/${module.id}/${module.version}`);

            const data = await this.xhr(method, url);
            const res = await JSON.parse(data);
            if (res.error){
                return ({error: res.error});
            }
        }

        return ({result: 'OK'});
    }
}
